
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movie/[slug]",
      function () {
        return require("private-next-pages/movie/[slug].tsx");
      }
    ]);
  